import { useMutation } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/react-query';
import { ChangePasswordRequest } from '@/types/user/password-change';

// パスワードを変更するためのAPI呼び出し関数
export const putChangePassword = async ({
  params,
}: {
  params: ChangePasswordRequest;
}) => {
  console.info('put-password.ts_1');
  await api.put('/user/password', params);
};

type useChangePasswordPut = {
  mutationConfig?: MutationConfig<typeof putChangePassword>;
};

export const useChangePasswordPut = ({
  mutationConfig,
}: useChangePasswordPut) => {
  console.info('put-password.ts_2');

  return useMutation({
    mutationFn: putChangePassword,
    ...mutationConfig,
  });
};
